// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"like_wrapper__nTGZ6"};